import script from "./legacy-p9-report.vue?vue&type=script&setup=true&lang=js"
export * from "./legacy-p9-report.vue?vue&type=script&setup=true&lang=js"

import "./legacy-p9-report.vue?vue&type=style&index=0&id=6f33256a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f33256a"]])

export default __exports__